/*
 *
 * AssignInvestigator constants
 *
 */

export const DEFAULT_ACTION = "app/AssignInvestigator/DEFAULT_ACTION";
export const ASSIGN_INVESTIGATOR = "AssignInvestigator/assign"
export const FILTER_STATE = 'AssignInvestigator/filter/by/state'
export const FILTER_CITY = 'AssignInvestigator/filter/by/city'